import axios from "@/axios";
import store from "@/store";

const state = {
  selectedAddress: null,
  addresses: [],
  loading: false,
};

const getters = {
  retrieveAddresses: (state) => {
    return state.addresses;
  },

  retrieveSelectedAddress: (state) => {
    return state.selectedAddress;
  },

  retrieveDeliveryAddressesLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  async clearAddresses({ commit }) {
    commit("setSelectedAddress", null);
    commit("setAddresses", []);
    commit("setDeliveryAddressesLoading", false);
  },

  async getSelectedDeliveryAddress({ commit }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    commit("setDeliveryAddressesLoading", true);

    const response = await axios.post(
      "general/get-selected-delivery-address",
      params
    );

    commit("setDeliveryAddressesLoading", false);

    if (response) {
      if (response.data.success == true) {
        console.log("-- Response Data");
        console.log(response.data);
        commit("setSelectedAddress", response.data.address);
        return {
          success: response.data.success,
          address: response.data.address,
        };
      } else {
        commit("setAddresses", []);
        return {
          success: response.data.success,
          address: {},
        };
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async getUserDeliveryAddresses({ commit }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    commit("setDeliveryAddressesLoading", true);

    const response = await axios.post(
      "general/get-user-delivery-addresses",
      params
    );

    commit("setDeliveryAddressesLoading", false);

    if (response) {
      if (response.data.success == true) {
        console.log("-- User Addresses Response Data");
        console.log(response.data);
        commit("setAddresses", response.data.addresses);
        commit("setSelectedAddress", response.data.selected_address);
        return {
          success: response.data.success,
        };
      } else {
        commit("setAddresses", []);
        return {
          success: response.data.success,
        };
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async searchDeliveryAddresses({ commit }, search) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      search: search,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post(
      "general/search-delivery-addresses",
      params
    );

    if (response) {
      if (response.data.success == true) {
        console.log("-- User Addresses Response Data");
        console.log(response.data);
        commit("setAddresses", response.data.addresses);
        commit("setSelectedAddress", response.data.selected_address);
        return {
          success: response.data.success,
        };
      } else {
        commit("setAddresses", []);
        return {
          success: response.data.success,
        };
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async convertUserDeliveryAddress({ commit }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post(
      "general/convert-user-delivery-address",
      params
    );

    if (response) {
      if (response.data.success == true) {
        console.log("-- Convert Address Response Data");
        console.log(response.data);
        commit("setSelectedAddress", response.data.address);
        return response.data.success;
      } else {
        return response.data.success;
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async selectUserDeliveryAddress({ commit }, id) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      id: id,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post(
      "general/select-user-delivery-address",
      params
    );

    if (response) {
      if (response.data.success == true) {
        console.log("-- Convert Address Response Data");
        console.log(response.data);
        commit("setSelectedAddress", response.data.selected_address);
        return response.data.success;
      } else {
        return response.data.success;
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async deleteDeliveryAddress({ commit }, id) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      id: id,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post(
      "general/delete-delivery-address",
      params
    );

    if (response) {
      if (response.data.success == true) {
        console.log("-- Delete Address Response Data");
        console.log(response.data);
        return response.data.success;
      } else {
        return response.data.success;
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async createDeliveryAddress({ commit }, { data }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      data: data,
    };

    console.log(payload);

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post(
      "general/create-delivery-address",
      params
    );

    if (response) {
      if (response.data.success == true) {
        console.log("-- Create Address Response Data");
        console.log(response.data);
        commit("setSelectedAddress", response.data.address);
        return response.data.success;
      } else {
        store.dispatch("setSnackbar", {
          color: "error",
          text: response.data.messages[0],
        });

        return response.data.success;
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async updateDeliveryAddress({ commit }, { id, data }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      id: id,
      data: data,
    };

    console.log(payload);

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const response = await axios.post(
      "general/update-delivery-address",
      params
    );

    if (response) {
      if (response.data.success == true) {
        console.log("-- Update Address Response Data");
        console.log(response.data);
        return response.data.success;
      } else {
        store.dispatch("setSnackbar", {
          color: "error",
          text: response.data.messages[0],
        });

        return response.data.success;
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },
};

const mutations = {
  setAddresses: (state, value) => (state.addresses = value),
  setSelectedAddress: (state, value) => (state.selectedAddress = value),
  setDeliveryAddressesLoading: (state, value) => (state.loading = value),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
